import {
  type ApplicationConfig,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZonelessChangeDetection,
} from '@angular/core';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { credentialsInterceptor } from './auth/credentials.interceptor';
import { errorInterceptor } from './auth/error.interceptor';
import { ROUTES } from './app.routing';
import { AuthService } from './auth/auth.service';
import { firstValueFrom } from 'rxjs';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideAnimationsAsync(),
    provideRouter(ROUTES, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptors([errorInterceptor, credentialsInterceptor])),
    provideAppInitializer(() => firstValueFrom(inject(AuthService).initializeAuth())),
    {
      provide: LOCALE_ID,
      useValue: window.navigator.language,
    },
  ],
};
